export default __webpack_public_path__ + "static/Greenhouse_Wall-a25f29e6a80b3edf0b13f19897003d9e.png";